import { TextBox } from "./usefulContainers";


const questions = [
    {
        question: "Why am I here?",
        answer: "If you were directed here it is probably because Sebastian was right about something."
    },
    {
        question: "What if I think Sebastian is wrong?",
        answer: "This is a common symptom of Inaccurate Perception Disorder (IPD). We recommend reading the latest installment of the DSM to help you deal with your newfound condition."
    },
    {
        question: "Who funds this foundation?",
        answer: "The foundation is funded by the people of this world who seek to learn more and understand how not to be an idiot."
    },
    {
        question: "I found that Sebastian has made a typo. Sebastian wrong about spelling?",
        answer: "No. Sebastian has decided to revolutionize the English language. That is the new way to spell that word. Please update your vocabulary."
    }
]


export function Qanda() {
    const currentYear = new Date().getFullYear();
    return (
        <TextBox>
            <h2>Commonly asked Questions:</h2>
            {questions.map((set: { question: any, answer: any }) => (
                <div>
                    <b>{set.question}</b>
                    <br/>
                    {set.answer}
                    <br/>
                    <br/>
                </div>
            ))}
            <div>
                <b>How do I cite the Foundation in an academic paper?</b>
            </div>
            Use the standard MLA format: <br />Sebastian. "Everything." The Universe, vol. 1, Foundation Press, {currentYear}.
            <br/>
            <br/>
            <div>
                <b>How do I report a "Sebastian Lapse"?</b>
            </div>
            To report an inaccuracy you believe you have found in something Sebastian has said or written please submit your findings &nbsp;
            <a href="https://988lifeline.org/" target="_blank" rel="noopener noreferrer" style={{ color: "lightblue" }}>
                HERE.
            </a>
            <br />
            <br />
        </TextBox>
    )
}